/** How the create page lays a form out. Unset = `default` (today's single column). */
export const CreateFormLayoutEnum = <const>{
  Default: 'default',
  Summary: 'summary',
};
export type CreateFormLayout = (typeof CreateFormLayoutEnum)[keyof typeof CreateFormLayoutEnum];

/** How one summary row turns its model value into text. Unset = `text`. */
export const SummaryFormatEnum = <const>{
  Text: 'text',
  Date: 'date',
  Route: 'route',
  Repeat: 'repeat',
};
export type SummaryFormat = (typeof SummaryFormatEnum)[keyof typeof SummaryFormatEnum];

export interface SummaryRowConfig {
  label: string;
  /** Model path on the form, without `entry.` — e.g. `company`. */
  path: string;
  format?: SummaryFormat;
  /**
   * Read when `path` holds nothing. Lets one row cover two shapes of the same answer: a
   * Frequentie row reads the `repeat` object of a repeating order and falls back to the
   * chosen `soort` option of a one-off one.
   */
  fallbackPath?: string;
}

/** `sourceFormSettings.summary` — what the summary card of the `summary` layout shows. */
export interface SummarySettings {
  /** Model path whose value is the card title. */
  titleField?: string;
  /** Model path of a date; renders as `<dd-MM-yyyy> • Week <n>`. */
  subtitleField?: string;
  rows: SummaryRowConfig[];
}

/** One rendered summary row. */
export interface SummaryRow {
  label: string;
  value: string;
}
